import { useQuery } from '@tanstack/react-query';
import tourPricesApi from '@/features/dashboard/tourConfig/api/tourPricesApi.ts';
import { tourPricesApiQueryKeys } from '@/features/dashboard/tourConfig/api/tourPricesApi.queryKeys.ts';

const useGetTourPrices = (tourId: string | undefined) => {
  return useQuery({
    queryKey: tourPricesApiQueryKeys.byTour(tourId!),
    queryFn: () => tourPricesApi.getPrices(tourId!),
    staleTime: 1000 * 60,
    enabled: !!tourId,
    retry: 1,
  });
};

export default useGetTourPrices;
